import { useSitrepSectionWizardContext } from './SitrepSectionWizardContext';
import { PratusStepper } from '../../DesignSystems/PratusStepper/PratusStepper';
import React from 'react';
import { SITREP_SECTION_STEPS } from './types';

/**
 * This component renders the stepper and label for each step in the Sitrep
 * Section Wizard.
 */
const SitrepSectionWizardHeader = () => {
  const { activeStep } = useSitrepSectionWizardContext();
  return (
    <div className="sidebar-header">
      <div className="stepper-container mt-3 px-3">
        <PratusStepper
          steps={SITREP_SECTION_STEPS}
          activeStep={activeStep.id}
          showLabel={false}
        />
      </div>
      <h3 className="align-self-center m-0">{activeStep.label}</h3>
    </div>
  );
};

export default SitrepSectionWizardHeader;
